import {Action, Selector, State, StateContext, StateToken, Store} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {GetUserPortalActiveDiscount} from '../actions/discount.action';
import {UserProfileApiService} from '../api/user-profile-api.service';
import {UserDiscountModel} from '../models/user-discount.model';
import {catchError, filter, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {MastersStateModel} from './masters.state';


export interface DiscountStateModel {
  activeDiscount: UserDiscountModel;
}

const initialState: DiscountStateModel = {
  activeDiscount: null,
};

@State<DiscountStateModel>({
  name: new StateToken<DiscountStateModel>('discount'),
  defaults: initialState
})
@Injectable()
export class DiscountState {

  constructor(
    private store: Store,
    private userProfileService: UserProfileApiService,
  ) {
  }

  @Action(GetUserPortalActiveDiscount)
  handleGetUserPortalActiveDiscountAction(ctx: StateContext<DiscountStateModel>, action: GetUserPortalActiveDiscount) {

    return this.userProfileService.getUserPortalActiveDiscount().pipe(
      filter(value => value !== null),
      tap( data => {
        const state = ctx.getState();
        ctx.patchState({
          activeDiscount: data,
        });

      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  @Selector()
  static getActiveDiscount(state: DiscountStateModel) {
    return state?.activeDiscount;
  }

}
